import { render } from "./AppDialog.vue?vue&type=template&id=070e53ba"
import script from "./AppDialog.vue?vue&type=script&lang=ts"
export * from "./AppDialog.vue?vue&type=script&lang=ts"
script.render = render

export default script